<template>
  <v-dialog
    v-model="dialog"
    class="ch-dialog"
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-users fa-fw"></i>
          <span class="title">NEW STAFF</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">NAME *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">EMAIL *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">PASSWORD *</div>
                <div class="form-input">
                  <v-text-field
                    class="ch-input-pwd"
                    v-model="password"
                    :rules="passwordRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group form-textarea-group">
                <div class="form-title">DESCRIPTION *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="desc"
                    :rules="descRules"
                    full-width
                    textarea
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">HOTEL *</div>
                <div class="form-input">
                  <v-select
                    :items="hotelItems"
                    v-model="getHotelName"
                    item-text="name"
                    item-value="id"
                    full-width
                    @click.native="getHotelList"
                    @focus.native="getHotelList"
                    autocomplete
                    :rules="hotelRules"
                    single-line
                    content-class="create-autocomplete-select"
                  ></v-select>
                </div>
              </div>
              <!-- TODO: 호텔이 선택되면 렌더링, 선택되어진 체크박스의 아이디값만 배열로 리셋 -->
              <div class="form-checkbox-group" v-if="getHotelName">
                <div class="form-title">PERMISSION</div>
                <div class="form-checkbox">
                  <div
                    class="checkbox-wrapper"
                    v-for="(permissionItem, index) in permissionItems"
                    :key="permissionItem.id"
                  >
                    <v-checkbox :label="getRoleString(permissionItem.role)" v-model="permissions[index]" :value="permissionItem.id"></v-checkbox>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createStaff"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
        <!-- <v-btn
          color="error"
          @click.native="clearAllField"
        >
          <v-icon class="mr-2">clear_all</v-icon>
          Clear All
        </v-btn> -->
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { staffsEventBus } from '@/components/admin/staffs/staffsEventBus';
  import api from '../../../api';
  import PermissionModel from '../../../permissions';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        // id: this.$route.params.id,
        email: null,
        password: null,
        name: null,
        desc: null,
        hotelItems: [],
        hotel: null,
        // NOTE: 선택된 호텔의 전체 permission
        permissionItems: [],
        permissions: [],
        // NOTE: Dialog
        saveDialog: false,
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
        emailRules: [
          v => (v === 0) || !!v || 'Please input Email',
          /* eslint max-len: ["error", { "code": 200 }] */
          v => /^\w+([\\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
          v => (v === 0) || !!v || 'Please input Password',
        ],
        descRules: [
          v => (v === 0) || !!v || 'Please input Description',
        ],
        hotelRules: [
          v => (v === 0) || !!v || 'Please input Hotel',
        ],
      };
    },
    methods: {
      getHotelList() {
        const query = {
          limit: 1000,
        };
        api.getHotelList(query)
        .then((result) => {
          if (result.status === 200) {
            // NOTE: 호텔의 name과 id 필요
            this.hotelItems = result.data.map((obj) => {
              const newObj = {};
              newObj.id = obj.id;
              newObj.name = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getHotelPermission(param) {
        api.getHotelPermission(param)
        .then((result) => {
          if (result.status === 200) {
            this.permissionItems = result.data.filter(r => r.type === 'igrms' || r.type === 'staffapp');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 선택된 checkbox의 아이디값을 새 배열로 반환
       */
      getPermissions() {
        return this.permissions.filter(item => (item !== undefined) && (item !== null) && item !== '');
      },
      createStaff() {
        const params = {
          name: this.name,
          email: this.email,
          password: this.password,
          desc: this.desc,
          permission_ids: this.getPermissions(),
        };
        // console.table(params);
        api.createStaff(this.hotel, params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Create';
            this.alertOccur();
            staffsEventBus.$emit('reloadList');
            this.closeDialog();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
      getRoleString(role) {
        return PermissionModel.getRoleString(role);
      },
    },
    computed: {
      getHotelName: {
        get() {
          return this.hotel;
        },
        set(newValue) {
          this.hotel = newValue;
          if (this.hotel) {
            this.getHotelPermission(this.hotel);
          }
        },
      },
    },
    mounted() {
      staffsEventBus.$on('openDialog', () => {
        console.info('openDialog');
        this.openDialog();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/staffs/CreateStaff.vue